module.exports = __webpack_public_path__ + "img/hbd.e2d3ecf5.png";